import { Loading } from 'element-ui'

//loading参数配置
export const loadingConfig = {
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
}
let loading = null ;
//显示
const show = () => {
    loading = Loading.service(loadingConfig);
}
//关闭
const close = (type) => {
    if (type === null){
        loading.close();
        return;
    }
    setTimeout(function () {
        loading.close();
    },300)
    //loading.close();
}

export default {
    show(){
        show();
    },
    close(type){
        close(type);
    }
}
